import { Cpu, Workflow, BrainCircuit, Server, ShieldCheck, Database } from "lucide-react";
import { useLang } from "../context/LangContext";
import { Seo } from "../components/Seo";
import NeuralBackground from "../components/NeuralBackground";

const ITEMS = [
  { icon: Cpu, es: ["Tecnología", "Desarrollo de plataformas, arquitectura de sistemas y soporte tecnológico transversal para todas las marcas del grupo."], en: ["Technology", "Platform development, systems architecture and cross-cutting technology support for all group brands."] },
  { icon: Workflow, es: ["Automatización", "Diseño de procesos automatizados que reducen trabajo manual, clics y errores operativos."], en: ["Automation", "Automated process design reducing manual work, clicks and operational errors."] },
  { icon: BrainCircuit, es: ["Inteligencia Artificial", "IA aplicada a operaciones, análisis de datos y toma de decisiones corporativas."], en: ["Artificial Intelligence", "AI applied to operations, data analysis and corporate decision-making."] },
  { icon: Server, es: ["Infraestructura Digital", "Infraestructuras seguras, escalables y monitorizadas para todo el ecosistema."], en: ["Digital Infrastructure", "Secure, scalable and monitored infrastructure for the entire ecosystem."] },
  { icon: ShieldCheck, es: ["Gobierno Corporativo", "Centralización documental, legal y de cumplimiento como fuente única de verdad."], en: ["Corporate Governance", "Document, legal and compliance centralization as single source of truth."] },
  { icon: Database, es: ["Datos y Plataformas", "Gestión centralizada de plataformas, marcas y activos digitales del grupo."], en: ["Data & Platforms", "Centralized management of group platforms, brands and digital assets."] },
];

export default function OperadorDigital() {
  const { t, lang } = useLang();
  return (
    <div data-testid="operator-page">
      <Seo page="operador-digital" />
      <section className="relative border-b border-slate-200 overflow-hidden">
        <NeuralBackground />
        <div className="hero-orb w-[500px] h-[500px] -right-32 -top-32 opacity-40" />
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-24 relative z-10">
          <span className="font-mono-tech text-xs tracking-[0.3em] text-[#5698C7]">OPERADOR DIGITAL</span>
          <h1 className="font-display font-black text-4xl sm:text-5xl lg:text-6xl tracking-tight mt-4 max-w-3xl" data-testid="operator-title">{t("operator_h1")}</h1>
          <p className="text-slate-600 max-w-2xl mt-6">{t("operator_sub")}</p>
        </div>
      </section>
      <section className="max-w-7xl mx-auto px-4 sm:px-6 py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {ITEMS.map((it, i) => (
            <div key={i} className="hud-border bg-white p-10 group" data-testid={`operator-item-${i}`}>
              <it.icon size={28} strokeWidth={1} className="text-[#5698C7] mb-6" />
              <h3 className="font-display text-base font-medium mb-3 group-hover:text-[#5698C7] transition-colors duration-200">{it[lang]?.[0] || it.es[0]}</h3>
              <p className="text-xs text-slate-500 leading-relaxed">{it[lang]?.[1] || it.es[1]}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
